import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from "../components/Login";
import Index from "../components/Index";
import Home from "../components/Home";
import Customer from "../components/Customer";
import AddCustomer from "../components/AddCustomer";
import FindCustomer from "../components/FindCustomer";
import Dealer from "../components/Dealer";
import ModifyInfo from "../components/ModifyInfo";
import UpdatePassword from "../components/update/UpdatePassword";
import UpdateNickname from "../components/update/UpdateNickname";
import yt from "../components/yt";
import findDealer from "../components/findDealer";
import Error from "../components/infoPage/Error";
import AddDealer from "../components/AddDealer";
import Account from "../components/Account";
import FindExpress from "../components/FindExpress";
import NotFound from '../components/infoPage/404'
import AddExpress from "../components/express/AddExpress";
import ReviewList from "../components/customer/ReviewList.vue";


Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({

  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/yt'
    },
    {
      path: '/yt',
      component: yt,
      redirect: '/findDealer',
      children: [
        {
          path: '/findDealer',
          component: findDealer
        },
        {
          path: '/findExpress',
          component: FindExpress
        },
      ]
    },
    {
      path: '/login',
      component: Login
    },

    {
      path: '/index',
      name: 'index',
      component: Index,
      // redirect: 'home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home
        },
        {
          path: 'customer',
          name: 'Customer',
          component: Customer
        },
        {
          path: 'add',
          name: 'add',
          component: AddCustomer
        },
        {
          path: 'addDealer',
          name: 'AddDealer',
          component: AddDealer
        },
        {
          path: 'review',
          name: 'ReviewList',
          component: ReviewList
        },
        {
          path: 'findCustomer',
          component: FindCustomer
        },
        {
          path: 'dealer',
          component: Dealer
        },
        {
          path: 'account',
          component: Account
        },
        {
          path: 'addExpress',
          component: AddExpress
        },
        {
          path: 'modify',
          name: 'Modify',
          component: ModifyInfo,
          redirect: 'modify/updatePassword',
          children: [
            {
              path: 'updatePassword',
              component: UpdatePassword
            },
            {
              path: 'updateNickname',
              component: UpdateNickname
            }
          ]
        }
      ]
    },
    {
      path: '/error',
      component: Error
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }

  ]
});

import axios from 'axios'
//路由守卫
router.beforeEach(((to, from, next) => {
  if (!(to.path.startsWith('/index') )) {
    if (window.localStorage.getItem('access-admin')) {
      window.localStorage.removeItem('access-admin')
    }
  }

  if (to.path.startsWith("/login")) {
    // window.localStorage.removeItem('access-admin')
    next()
  } else if (to.path == '/findDealer' || to.path == '/findExpress') {
    // window.localStorage.removeItem('access-admin')
    next()
  } else {
    let adminPaths = ['/index/account', '/index/dealer', '/index/addExpress']
    let admin = JSON.parse(localStorage.getItem('access-admin'))
    if (!admin) {
      next({path: '/login'})
    } else {
      //校验token合法性
      axios({
        url: 'https://yuanteng.tech:8081/user/checkToken',
        method: 'get',
        headers: {
          token: admin.token
        }
      }).then(res => {
        if (!res.data) {
          this.$message.error("没有访问权限")
          console.log("校验失败")
          next({path: '/error'})
        }
      })
      if (decodeURIComponent(window.atob(admin.role)) !== "ADMIN" && adminPaths.includes(to.path)) {
        next({path: '/index/home'})
      }
      next()
    }
  }
  // if (to.path === '/login') {
  //   next();
  // }
  // const user = localStorage.getItem("user");
  // if (!user && to.path !== '/login' && to.path !== '/findDealer') {
  //   return next('/login');
  // }
  // next();
}))

export default router



// WEBPACK FOOTER //
// ./src/router/index.js